import { useCallback, useContext, useEffect, useRef, useState } from "react";
import ImageComponent from "../../common/ImageComponent.jsx";
import ProfileAvatar from "../../common/ProfileAvatar.jsx";
import { PROFILE, NEW_PROFILE_DOCTOR, NEW_PROFILE_FACILITY, NEW_PROFILE_INDUSTRY } from "../../../constants/RoutesUrl.js";
import { _imagesURL, DeletePostApi, EditPostApi } from "../../../constants/API";
import Avatar from "../../../assets/images/icon/placeholder_Awatar.png";
import Dots from "../../../assets/images/icon/post-dropdown-dots.png";
import { Link } from "react-router-dom";
import { UnixToRelative } from "../../notification/Notification.jsx";
import { Modal, ModalBody, Spinner, ModalHeader, Col } from "reactstrap";
import { FeedDataRefetch, Language } from "../../../App.jsx";
import { toast } from "react-toastify";
import axios from "axios";
import { authorize } from "../../../shared/authorize.js";
import RepostUserModal from "../modals/RepostUserModal.jsx";
import InviteWebinarPopup from "../postTabs/InviteWebinarPopup.jsx";
import ShareModal from "../modals/ShareModal.jsx";
import PostHeaderDropdown from "./PostHeaderDropdown.jsx";
import MixpanelManager from "../../../constants/MixpanelManager";
import { MixpanelEvents } from "../../../constants/MixpanelEvents";
import { BsThreeDots } from "react-icons/bs";
import "./PostHeaderDropdown.css";
const PostHeader = ({
  postDetails,
  postDropDown,
  setPostDropDown,
  setReportModal,
  setDropDownId,
  dropDownId,
  isSave,
  isShare,
  shares_count,
  handleSave,
  handleRepost,
  type,
  isFollow,
  handleFollow,
  setShowPost,
  editWebinarTab,
  editPostTab,
  setEditPost,
  editPost,
  handlePostSelect,
  profilePage,
  updatePost,
  deletePost
}) => {
  const { lang } = useContext(Language);
  const { updateRefetch } = useContext(FeedDataRefetch);
  const collapseRef = useRef(null);
  const userData = localStorage.getItem("SignupData");
  const user = userData ? JSON.parse(userData) : null;
  const user_id = user?.data?.id;
  const [inviteWebinar, setInviteWebinar] = useState(false)
  const [webinarType, setWebinarType] = useState(null)
  const [editPostInput, setEditPostInput] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = useCallback((id) => {
    // setPostId(id);
    setModalOpen((prev) => !prev);
  }, []);
  const handleDeletePost = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${DeletePostApi}${postDetails.original_id}`, authorize());
      if (response.data.status) {
        MixpanelManager.track(MixpanelEvents.deletePost, {
          post_id: postDetails.original_id,
          user_id: user_id,
          post_type: type
        });
        setDeleteModal(false);
        if (!profilePage) {
          deletePost(postDetails.original_id)
        } else {
          window.location.reload();
        }
      } else {
        toast.error(response.data.action);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditPost = async () => {
    setIsLoading(true);
    try {
      const editData = { caption: editPostInput, post_id: dropDownId };
      const response = await axios.post(EditPostApi, editData, authorize());
      if (response.data.status) {
        MixpanelManager.track(MixpanelEvents.editPost, {
          post_id: dropDownId,
          user_id: user_id,
          caption_length: editPostInput.length
        });
        setEditModal(false);
        updateRefetch();
        updatePost(dropDownId, editPostInput);
      } else {
        toast.error(response.data.action);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const [ignoreNextOutsideClick, setIgnoreNextOutsideClick] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ignoreNextOutsideClick) {
        setIgnoreNextOutsideClick(false);
        return;
      }

      const dropdownEl = document.querySelector('.mr-post-dropdown-menu');
      const isClickInsideDropdown = dropdownEl?.contains(event.target);
      const isClickInsideDotsButton = event.target.closest?.('.mr-post-dots-btn, .dots-button');
      const isClickInsidePopup = document.querySelector(".modal.d-block")?.contains(event.target);

      if (!isClickInsideDropdown && !isClickInsideDotsButton && !isClickInsidePopup) {
        setPostDropDown(false);
        setIsOpen(false);
      }
    };

    if (postDropDown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [postDropDown, ignoreNextOutsideClick]);

  const handleDotsClick = (e) => {
    e.stopPropagation();
    if (postDropDown) {
      setPostDropDown(false);
      setIsOpen(false);
    } else {
      setPostDropDown(true);
      setDropDownId(postDetails?.original_id);
    }
  };
  const isOwner = postDetails?.user?.id === user_id;
  return (
    <>
      <div className="d-flex justify-content-between align-items-center position-relative px-2 px-sm-3 py-1 mr-post-header-inner">
        {profilePage ? (
          <Col md={10} className="d-flex gap-3">
            <ProfileAvatar
              src={postDetails?.user?.image}
              size={44}
              variant="subtle"
              alt={postDetails?.user?.name || "Author"}
            />
            <div className="align-self-center">
              <h1 className="fs-15 roboto-bold mb-0" style={{ color: "#0F1A2B" }}>
                {postDetails?.user?.name}
              </h1>
              <span className="fs-12 roboto-regular" style={{ color: "#5F6673" }}>
                <UnixToRelative unixTimestamp={postDetails?.time} />
              </span>
            </div>
          </Col>
        ) : (
          <div className="d-flex gap-2 gap-sm-3 align-items-center min-w-0 flex-grow-1">
            <ProfileAvatar
              src={postDetails?.user?.image}
              size={44}
              variant="subtle"
              link={
                postDetails?.user?.user_type === "facility"
                  ? NEW_PROFILE_FACILITY + "/" + (postDetails?.user?.user_name || postDetails?.user?.id)
                  : postDetails?.user?.user_type === "industry"
                    ? NEW_PROFILE_INDUSTRY + "/" + (postDetails?.user?.user_name || postDetails?.user?.id)
                    : NEW_PROFILE_DOCTOR + "/" + (postDetails?.user?.user_name || postDetails?.user?.id)
              }
              alt={postDetails?.user?.name || "Author"}
            />
            <div className="align-self-center min-w-0 flex-grow-1">
              <div className="d-flex flex-column min-w-0">
                <div className="d-flex align-items-center gap-2 min-w-0">
                  <Link
                    to={
                      postDetails?.user?.user_type === "facility"
                        ? NEW_PROFILE_FACILITY + "/" + (postDetails?.user?.user_name || postDetails?.user?.id)
                        : postDetails?.user?.user_type === "industry"
                          ? NEW_PROFILE_INDUSTRY + "/" + (postDetails?.user?.user_name || postDetails?.user?.id)
                          : NEW_PROFILE_DOCTOR + "/" + (postDetails?.user?.user_name || postDetails?.user?.id)
                    }
                    className="min-w-0"
                  >
                    <h1
                      className="fs-15 roboto-bold hover-blue mb-0 text-truncate"
                      style={{ color: "#0F1A2B", maxWidth: "200px" }}
                    >
                      {postDetails?.user?.name}
                    </h1>
                  </Link>
                  {type === "clinical-image" && (
                    <span
                      className="roboto-bold flex-shrink-0"
                      style={{
                        fontSize: "10px",
                        padding: "2px 8px",
                        borderRadius: "999px",
                        background: "#ECFDF5",
                        color: "#059669",
                        border: "1px solid #A7F3D0",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Clinical Case
                    </span>
                  )}
                  {type === "webinar" && (
                    <span
                      className="roboto-bold flex-shrink-0"
                      style={{
                        fontSize: "10px",
                        padding: "2px 8px",
                        borderRadius: "999px",
                        background: "#FEF3C7",
                        color: "#D97706",
                        border: "1px solid #FDE68A",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Webinar
                    </span>
                  )}
                </div>
                <p className="mb-0 fs-12 roboto-regular mt-0.5" style={{ color: "#5F6673" }}>
                  {lang.posted || "Posted"} <UnixToRelative unixTimestamp={postDetails?.time} />
                </p>
              </div>
            </div>
          </div>
        )}
        <div className="position-relative d-flex align-items-center">
          <button
            type="button"
            className={`mr-post-dots-btn dots-button ${postDropDown && postDetails?.original_id === dropDownId ? "active" : ""}`}
            onClick={handleDotsClick}
            aria-label="Post options"
          >
            <BsThreeDots size={18} />
          </button>
          {/* Post DropDown */}
          <PostHeaderDropdown
            postDetails={postDetails}
            postDropDown={postDropDown}
            setPostDropDown={setPostDropDown}
            dropDownId={dropDownId}
            type={type}
            isSave={isSave}
            isShare={isShare}
            shares_count={shares_count}
            isFollow={isFollow}
            isOwner={isOwner}
            user_id={user_id}
            lang={lang}
            handleSave={handleSave}
            handleRepost={handleRepost}
            handleFollow={handleFollow}
            setReportModal={setReportModal}
            setEditModal={setEditModal}
            setDeleteModal={setDeleteModal}
            setShowPost={setShowPost}
            editWebinarTab={editWebinarTab}
            editPostTab={editPostTab}
            setEditPost={setEditPost}
            editPost={editPost}
            handlePostSelect={handlePostSelect}
            setInviteWebinar={setInviteWebinar}
            setWebinarType={setWebinarType}
            setShareModal={setShareModal}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            toggleRepostModal={toggleModal}
            setEditPostInput={setEditPostInput}
          />
          {/* End Post DropDown */}
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        isOpen={deleteModal}
        toggle={() => setDeleteModal(false)}
        centered
        zIndex={1060}
      >
        <ModalBody>
          <div className="pr-62px">
            <h2 className="text-blue fs-21 fs-md-16 roboto-bold">
              {lang?.do_want_delete_post}
            </h2>
            <p className="fs-16 fs-md-15 roboto-regular">
              {lang?.after_deleting_post_see_post}
            </p>
          </div>
          <hr />
          <div className="d-flex justify-content-end gap-3">
            <button
              className="manue-hover text-dark border-1 border rounded w-100 py-2 fs-md-14"
              onClick={() => {
                setDeleteModal(false);
              }}
            >
              {lang?.cancel}
            </button>
            <button
              className="btn-red border-0 rounded w-100 py-2 fs-md-14"
              onClick={handleDeletePost}
            >
              {isLoading ? <Spinner size={"sm"} /> : lang?.yes_delete}
            </button>
          </div>
        </ModalBody>
      </Modal>
      {/* End Delete Modal */}
      {inviteWebinar && <InviteWebinarPopup
        isOpen={inviteWebinar}
        webinarId={postDetails?.original_id}
        toggleModal={() => {
          setInviteWebinar(!inviteWebinar);
          setWebinarType(null)
        }}
        type={webinarType}
      />}
      {shareModal &&
        <ShareModal
          isOpen={shareModal}
          toggle={() => setShareModal(!shareModal)}
          type={type}
          postId={postDetails.original_id}
        />
      }
      {modalOpen && <RepostUserModal toggleModal={toggleModal} modal={modalOpen} postId={postDetails?.original_id} />}
    </>
  );
};

export default PostHeader;
